import * as React from 'react';
import { IntegrationLabels } from '../integration-labels';
import { ResponseTypes } from '../../../funds/funds-generated';

export class PlanningCenterPeopleConfigurationSectionOld extends React.Component<{viewModel: ResponseTypes.IntegrationViewModel, statusMessage: string, communityMembersUrl: string, instanceName: string}, {}> {

	render() {
		return (
			<div className="connection-section">
				<h2>
					<div>
						<span>{this.props.viewModel.Metadata.IntegrationSystem.DisplayName} - {this.props.instanceName}</span>
						<IntegrationLabels labels={this.props.viewModel.Content.PrimaryLabels} />
					</div>
				</h2>
				<div className="panel panel-default">
					<div className="panel-body">
						<p>
							{this.props.statusMessage}
						</p>
						<p>
							There are no settings to adjust here, but you can edit individual community member details
							from <a href={this.props.communityMembersUrl}>the Community screen</a>.
						</p>
					</div>
				</div>
			</div>
		);
	}
}
